export const successCTAs = {
    header: "Laissez-nous vous aider avec plus que votre prêt automobile!",
    subheader: "Assurance, cote de crédit, finalisation du prêt et plus encore…",
    ctas: [
        {
            name: "SONNET",
            title: "Assurance automobile en ligne",
            description: "Obtenez une soumission et achetez une assurance automobile en ligne instantanément. Vous pouvez protéger votre véhicule en seulement 5 minutes grâce aux régimes personnalisables de Sonnet.",
            link: "https://www.carloanscanada.com/insurance",
            buttonCta: "Demander une assurance",
        },
        {
            name: "BORROWELL",
            title: "Vérifications gratuites de la cote de crédit",
            description: "Votre cote de crédit détermine votre admissibilité et votre niveau de risque auprès des prêteurs ou de quiconque souhaite vous accorder du crédit.",
            link: "https://www.carloanscanada.com/credit-score",
            buttonCta: "Vérifier votre cote de crédit",
        },
        {
            name: "LOANS CANADA",
            title: "Finalisez votre prêt en ligne",
            description: "Trouvez une offre de prêt concurrentielle qui répond le mieux à vos besoins!",
            link: "https://loanscanada.ca/app/loan?affiliate_id=376",
            buttonCta: "Finaliser votre prêt",
        },
    ],
};
